import dateUtils from '@/common/dateUtils';
import dataUtils from '@/common/dataUtils';
import IN_MEMORY_DB from '@/modules/fahrdienst452/storeNonReactive';

class PerlschnurBuilder {
  /** Injects all necessary lookup objects */
  constructor({
    //fahrtBy_day_kurs,
    bemerkungIdBy_fahrtId_startOrtIdFk,
    bemerkungById,
    bemerkungIdBy_fahrtId_endOrtIdFk,
  }) {
    //this.fahrtBy_day_kurs = fahrtBy_day_kurs;
    this.bemerkungIdBy_fahrtId_startOrtIdFk = bemerkungIdBy_fahrtId_startOrtIdFk;
    this.bemerkungById = bemerkungById;
    this.bemerkungIdBy_fahrtId_endOrtIdFk = bemerkungIdBy_fahrtId_endOrtIdFk;
  }
  /**
   *
   * @param {Number} startToMinutesAfterMidnight Start minutes of tour or null if not selected
   * @param {Number} endToMinutesAfterMidnight End minutes of tour or null if not selected
   * @param {String} line (=Linie)
   * @param {String} track (=Kurs)
   * @param {String} dateIsoString day as ISO String
   * @returns
   */
  async calculateItems({
    startToMinutesAfterMidnight: startMinutesAfterMidnight = 0,
    endToMinutesAfterMidnight: endMinutesAfterMidnight = 60 * 28,
    line,
    track,
    dateIsoString,
  }) {
    // console.debug(`calculateItems for line ${line} / ${track}`);
    // console.time('log Perlschnur time');

    let fahrtList = [];
    let dateAsYYYYMMDD;
    let allTracksOfAdapterUmlaufAndDate;
    if (!startMinutesAfterMidnight) startMinutesAfterMidnight = 0;
    if (!endMinutesAfterMidnight) endMinutesAfterMidnight = 60 * 28;
    if (dateIsoString && (line || track)) {
      dateAsYYYYMMDD = dateUtils.reformatDateIsoStringAsYYYYMMDD(dateIsoString);

      // Select all fahrt items with equal adapterUmlauf (adapterUmlauf is track with an appended '0' in case of LVB. If it differs with other tenants, the calculation has to be delegated to tenant specific strategy)
      // fahrtList = dataUtils.getValueFromTwoLevelObject(IN_MEMORY_DB.fahrtBy_day_by_adapterUmlauf, dateAsYYYYMMDD, track + '0');
      // console.debug(`IN_MEMORY_DB.fahrtBy_day_by_adapterUmlauf[${dateAsYYYYMMDD}]`, Object.keys(IN_MEMORY_DB.fahrtBy_day_by_adapterUmlauf[dateAsYYYYMMDD]));
      // console.debug('IN_MEMORY_DB.fahrtBy_day_by_adapterUmlauf', Object.keys(IN_MEMORY_DB.fahrtBy_day_by_adapterUmlauf));
      fahrtList = dataUtils.getValueFromTwoLevelObject(IN_MEMORY_DB.fahrtBy_day_by_kurs, dateAsYYYYMMDD, track);
      if (fahrtList) console.debug('fahrt fahrtBy_day_by_kurs', dateAsYYYYMMDD, track);
      // retrieve fahrt items mapped by track+'0',track+'1' .., that is take all Umläufe into account. Later on select times between from to
      for (let i = 0; i < 4; i++) {
        let fahrtListTemp = dataUtils.getValueFromTwoLevelObject(IN_MEMORY_DB.fahrtBy_day_by_adapterUmlauf, dateAsYYYYMMDD, `${track}${i}`);
        if (fahrtListTemp) {
          console.debug(`concat fahrtListTemp from fahrtBy_day_by_adapterUmlauf ${dateAsYYYYMMDD} ${track}${i}`);
          fahrtList = fahrtList.concat(fahrtListTemp);
        }
      }
      // no data available (either date too old or no records at all)
      if (!fahrtList) return [];

      // Important notes:
      // There are tracks belonging to multiple Umlaufs, which cannot be detected by course field, but by using the field adapter_umlauf
      // If the user chooses such a track the native app asks the user which umlauf to display. This happends in fahrdienst452 (where it might make sense). However it happens in meindienst as well.
      // It is not necessary there since we can detect which fahrt items to display by selecting the ones building a chain within the requested time range.
      // An example for lvb is the kurs 13191 on 4.4.20222 and duty 91211 at the same date driving on the mentioned track.

      //  ==> If this feature should be required, the automatic selection in meinDienst has to be disabled wherea is fahrdienst452 the umlauf has to be choosen
      const SELECT_FIRST_UMLAUF_AUTOMATICALLY = false;
      if (SELECT_FIRST_UMLAUF_AUTOMATICALLY && fahrtList) {
        let adapter_umlauf = fahrtList[0].adapter_umlauf;

        allTracksOfAdapterUmlaufAndDate = dataUtils.getValueFromTwoLevelObject(IN_MEMORY_DB.fahrtBy_day_by_adapterUmlauf, dateAsYYYYMMDD, adapter_umlauf);
        if (allTracksOfAdapterUmlaufAndDate) {
          fahrtList = allTracksOfAdapterUmlaufAndDate;
        }
      }
    }
    let filtered = this.transformAndFilterFahrten(fahrtList, startMinutesAfterMidnight, endMinutesAfterMidnight);

    // Remove last item if it is a start entry
    let lastItem = dataUtils.lastItem(filtered);
    if (filtered.length > 1 && lastItem && lastItem.start) {
      console.debug('Remove last item if it is a start entry', JSON.stringify(lastItem, null, 2));
      filtered = filtered.slice(0, -1);
    }

    // Remove last item if ab time equals the ab time of the second last item
    // location is used from the last item
    // comment is merged
    if (filtered.length > 2) {
      let last = filtered[filtered.length - 1];
      let secondLast = filtered[filtered.length - 2];
      // console.debug("secondLast",JSON.stringify(last,null,2))
      // console.debug("last",JSON.stringify(last,null,2))
      if (last.ab === secondLast.ab && last.an === secondLast.an) {
        let removed = filtered.pop();

        filtered[filtered.length - 1].comment = filtered[filtered.length - 1].comment ? filtered[filtered.length - 1].comment : removed.comment;
        filtered[filtered.length - 1].location = removed.location;
        filtered[filtered.length - 1].connection = removed.connection;

        console.debug("remove last verlauf as it has the same 'ab' time", removed);
      }
    }

    // console.timeEnd('log Perlschnur time');
    return { transformedFahrten: filtered, includedTracks: [] };
    // return filtered;
  }
  transformAndFilterFahrten(fahrtList, startMinutesAfterMidnight, endMinutesAfterMidnight) {
    //  let sorted = fahrtList.slice().sort((f1, f2) => f1.fromMinutesAfterMidnight - f2.fromMinutesAfterMidnight);
    let sorted = fahrtList.sort((f1, f2) => f1.fromMinutesAfterMidnight - f2.fromMinutesAfterMidnight);
    let noDuplicates = [];
    let id;
    sorted.forEach((i) => {
      if (i.id !== id) noDuplicates.push(i);
      id = i.id;
    });
    let transformed = this.filterAndTransformTrackData(noDuplicates, startMinutesAfterMidnight, endMinutesAfterMidnight);
    return transformed;
  }
  /**
   * Transforms vdv_fahrt objects into the following rendering-ready structure:
   * {
   *   rowId: String // unique row id (e.g. for navigating to a special row)
   *   start: Boolean // indicates if the track has to be marked as "start", that is point with line to next location
   *   end: Boolean // indicates if the track has to be marked as "end", that is point with line from the previous location
   *   location: String // Haltestelle
   *   abbreviation: String // Kürzel (d. Haltestelle)
   *   line: String // Line
   *   course: String // Kurs
   *   zone: String // Zone
   *   an: Number
   *   arrivingTime: String // Renderered arriving time
   *   ab: Number
   *   departure: String // Rendered departure time
   *   comment: String // Bemerkung / Anschluss text
   * }
   */
  filterAndTransformTrackData(fahrtList, startMinutesAfterMidnight, endMinutesAfterMidnight) {
    let rows = [];
    let index = 0;
    for (let f = 0; f < fahrtList.length; f++) {
      let fahrt = fahrtList[f];
      let sortedVerlaeufeOfFahrt = this.getSortedVerlaeufeOfFahrt(fahrt);
      let fahrtDateAsTimeInMs = Date.parse(fahrt.day);
      let previousItem;
      for (let v = 0; v < sortedVerlaeufeOfFahrt.length; v++) {
        let verlauf = sortedVerlaeufeOfFahrt[v];
        let anAndAb = this.calcStartAndEndOfVerlauf({ fahrt, verlaufIndex: v, sortedVerlaeufeOfFahrt });

        // accept item only if it is within time range
        if (startMinutesAfterMidnight <= anAndAb.ab && anAndAb.an <= endMinutesAfterMidnight) {
          let bemerkung = this.bemerkung({ fahrt, verlauf, verlaufIndex: v, sortedVerlaeufeOfFahrt });
          let { longname, shortname, zone } = IN_MEMORY_DB.ortById[verlauf.ortIdFk] ? IN_MEMORY_DB.ortById[verlauf.ortIdFk] : {};
          let anschluss = this.anschluss({ fahrt, verlauf });

          let item = {
            // rowId: `V${fahrt.id}_${verlauf.id}`, // unique row id (e.g. for navigating to a special row)
            rowId: `${index}_an-${anAndAb.an}_ab-${anAndAb.ab}`, // unique row id (e.g. for navigating to a special row)
            index,
            isFirstOfVerlauf: v === 0,
            fahrtInd: f,
            verlaufInd: v,
            //rowId: `V${f}_${v}`, // unique row id (e.g. for navigating to a special row)
            fahrtDateAsTimeInMs,
            start: v === 0, // indicates if the track has to be marked as "start", that is point with line to next location
            end: v === sortedVerlaeufeOfFahrt.length - 1, // indicates if the track has to be marked as "end", that is point with line from the previous location
            inBetween: v > 0 && v < sortedVerlaeufeOfFahrt.length - 1,
            location: longname, // Haltestelle
            abbreviation: shortname, // Kürzel (d. Haltestelle)
            line: fahrt.linie, // Line
            track: fahrt.kurs, // Kurs
            zone, // Zone
            an: anAndAb.an,
            //arrivingTime: getLocalTimeFromMinutesAfterMidnight(anAndAb.an), // Rendered arriving time
            ab: anAndAb.ab,
            //departure: getLocalTimeFromMinutesAfterMidnight(anAndAb.ab), // Rendered departure time
            comment: bemerkung
              ? `${bemerkung.text ? bemerkung.text : ''} ${bemerkung.zeichen ? bemerkung.zeichen : ''} ${bemerkung.prio ? bemerkung.prio : ''}`
              : '', // Bemerkung / Anschluss text
            connection: anschluss, // anschluss
          };
          // skip when ab.previous=an item = ab item

          if (previousItem && item.ab === previousItem.ab && item.an === item.ab && item.start === false && item.end === false) {
            //console.debug("Skip item",JSON.stringify(item,null,2),JSON.stringify(previousItem,null,2))
          } else {
            rows.push(item);
            previousItem = item;
          }

          index++;
        }
      }
    }
    return rows;
  }
  getSortedVerlaeufeOfFahrt(fahrt) {
    let verlauefe = IN_MEMORY_DB.verlaufByAdapterLinieId[fahrt.adapter_linieId];
    // if (!verlauefe){
    //   verlauefe=IN_MEMORY_DB.verlaufByAdapterId[fahrt.adapter_id]
    // }
    if (verlauefe) {
      return verlauefe.sort((a, b) => a.sort - b.sort);
    }
    return [];
  }
  calcStartAndEndOfVerlauf({ fahrt, verlaufIndex, sortedVerlaeufeOfFahrt }) {
    let anMinutesAfterMidnight = fahrt.fromMinutesAfterMidnight;
    let abMinutesAfterMidnight = anMinutesAfterMidnight;
    let verlaeufe = sortedVerlaeufeOfFahrt;
    let start = verlaeufe[0];
    let startOrtIdFk = start ? start.ortIdFk : '';

    for (let i = 0; i <= verlaufIndex; i++) {
      let startShortName = IN_MEMORY_DB.ortById[startOrtIdFk].shortname;

      let haltezeit;
      haltezeit = IN_MEMORY_DB.haltezeitBy_fahrtId_ortId[`${fahrt.id}_${startOrtIdFk}`];
      // if (haltezeit) {
      //   console.debug('Found haltezeit from haltezeitBy_fahrtId_ortId (default)',startShortName, haltezeit);
      // }

      if (!haltezeit) {
        haltezeit = IN_MEMORY_DB.haltezeitBy_fahrtId_ortShortName[`${fahrt.id}_${startShortName}`];
        // if (haltezeit) console.debug('Found haltezeit from haltezeitBy_fahrtId_ortShortName', `${fahrt.id}_${startShortName}`, haltezeit);
      }
      if (!haltezeit) {
        haltezeit = IN_MEMORY_DB.haltezeitenFahrtgruppeBy_adapterId_ortId[`${fahrt.adapter_fgrNr}_${verlaeufe[i].ortIdFk}`];
      }

      if (haltezeit) {
        abMinutesAfterMidnight = anMinutesAfterMidnight + haltezeit / 60;
        if (i < verlaufIndex) anMinutesAfterMidnight = abMinutesAfterMidnight;
      }

      if (i < verlaufIndex) {
        let end = verlaeufe[i + 1];
        let endOrtIdFk = end ? end.ortIdFk : '';

        let fahrzeit;
        fahrzeit = IN_MEMORY_DB.fahrzeitBy_adapter_fgrNr_startOrtIdFk_endOrtIdFk[`${fahrt.adapter_fgrNr}_${startOrtIdFk}_${endOrtIdFk}`];

        if (!fahrzeit) {
          fahrzeit = IN_MEMORY_DB.fahrzeitBy_startOrtIdFk_endOrtIdFk[`${startOrtIdFk}_${endOrtIdFk}`];
        }
        if (!fahrzeit) {
          let startShortName = IN_MEMORY_DB.ortById[startOrtIdFk].shortname;
          let endShortName = IN_MEMORY_DB.ortById[endOrtIdFk].shortname;
          fahrzeit = IN_MEMORY_DB.fahrzeitBy_startOrtShortName_endOrtShortName[`${startShortName}_${endShortName}`];
        }

        if (fahrzeit) {
          let fahrzeitMin = fahrzeit / 60;
          anMinutesAfterMidnight += fahrzeitMin;
          abMinutesAfterMidnight += fahrzeitMin;
        } else {
          //console.debug('NO FAHRZEIT found for ', `${startOrtIdFk}=${startShortName}`);
        }

        start = end;
        startOrtIdFk = endOrtIdFk;
      }
    }
    return { an: anMinutesAfterMidnight, ab: abMinutesAfterMidnight };
  }
  bemerkung({ fahrt, verlauf, verlaufIndex, sortedVerlaeufeOfFahrt }) {
    if (verlaufIndex >= sortedVerlaeufeOfFahrt.length - 1) return;
    let bemerkung;
    if (verlauf.adapter_zielId) {
      bemerkung = { text: 'Ziel: ' + verlauf.adapter_zielId, prio: '', zeichen: '' }; // zeichen is currently not used
    }
    let startOrtIdFk = verlauf.ortIdFk;
    let endOrtIdFk = sortedVerlaeufeOfFahrt[verlaufIndex + 1].ortIdFk;

    let startkey = `${fahrt.id}_${startOrtIdFk}`;
    let endkey = `${fahrt.id}_${endOrtIdFk}`;

    let bemerkungsStartMap = this.bemerkungIdBy_fahrtId_startOrtIdFk[startkey];
    let bemerkungsEndMap = this.bemerkungIdBy_fahrtId_endOrtIdFk[endkey];
    // if (bemerkungsStartMap) // console.debug('Found bemerkungsStartMap', bemerkungsStartMap);
    // if (bemerkungsEndMap) // console.debug('Found bemerkungsEndMap', bemerkungsEndMap);
    if (bemerkungsStartMap && this.bemerkungById[bemerkungsStartMap.bemerkungIdFk]) {
      bemerkung = this.bemerkungById[bemerkungsStartMap.bemerkungIdFk];
    }
    if (bemerkungsEndMap && this.bemerkungById[bemerkungsEndMap.bemerkungIdFk]) {
      bemerkung = this.bemerkungById[bemerkungsEndMap.bemerkungIdFk];
    }
    return bemerkung;
  }
  anschluss({ fahrt, verlauf }) {
    let anschlussObj = IN_MEMORY_DB.fahrtAnschlussBy_fahrtId_ortId[`${fahrt.id}_${verlauf.ortIdFk}`];
    return anschlussObj ? anschlussObj : null;
  }
}

export default PerlschnurBuilder;
